import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TargetAvatarComponent } from './target-avatar.component';

@NgModule({
  declarations: [
    TargetAvatarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule
  ],
  exports: [
    TargetAvatarComponent
  ]
})
export class TargetAvatarModule { }
